import ajax from '../ajax'
//PS素材数据
export function PSImgApi(params) {
    return ajax({
        method:'get',
        url: 'v2/ps/index',
        params
    })
}
//模型获取标签数据
export function getPSLabelApi(params) {
    return ajax({
        method:'get',
        url: 'v2/ps/tag',
        params
    })
}
//模型图片移动
export function changePSImgApi(data) {
    return ajax({
        method:'post',
        url: 'v2/ps/changeProcess',
        data
    })
}
//模型获取图片弹窗标签(弹窗)
export function getPSImgLabelApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/ps/taglist',
        data
    })
}
//模型贴标签（弹窗 空格）
export function psLabelApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/ps/tagsave',
        data
    })
}
//模型贴标签（弹窗 右键）
export function rightPsLabelApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/ps/tagModel',
        data
    })
}
// 模型单个标签的是否情况(标签操作)
export function singPSleLabelApi(data) {
    return ajax({
        method:'POST',
        url: 'v2/ps/havetag',
        data
    })
}
//排序方式
export function showApi(params) {
    return ajax({
        method:'get',
        url: 'v2/ps/show',
        params
    })
}

//删除图片
export function deleteApi(data) {
    return ajax({
        method: 'POST',
        url: 'v2/ps/delete',
        data: data
    })
}









// 模型键盘1 or 2 事件（标签操作贴标签）
export function fingerboardNumApi(data) {
    return ajax({
        method:'POST',
        url: 'v2/model/onetag',
        headers: {
            'Content-Type': 'multipart/form-data'
          },
        data:data
    })
}

//模型改变图片状态
export function changeImgApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/ps/changeProcess',
        data
    })
}



//diy模型自定义标签获取
export function getDiyLabelApi(params) {
    return ajax({
        method:'get',
        url: 'v2/model/get',
        params
    })
}
//diy模型自定义标签添加
export function addDiyLabelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/add ',
        data
    })
}
//diy模型自定义标签移出
export function removeDiyLabelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/remove',
        data
    })
}
//diy模型自定义标签修改
export function rewriteDiyLabelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/rewrite',
        data
    })
}





// WEBPACK FOOTER //
// ./src/apis/ps/index.js